export const HOME = "/";

export const LOGIN = "/login";
export const PASSWORD_RESET = "/password-reset";

export const PROTECTED = "/u";
export const DASHBOARD = "/dashboard";

export const USERS = "/users";
export const TRANSACTIONS = "/transactions";
export const ENTRIES = "/entries";
export const ENTRIES_TOTALS = "/entries-totals";
export const DENIED_ENTRIES = "/denied-entries";
export const MEALS = "/meals";
export const MENUS = "/menus";
export const BOOKINGS = "/bookings";
export const SETTINGS = "/settings";
export const PROFILE = "/profile";
export const LIMITS = "/limits";
export const CHARGES = "/charges";
export const SURVEYS = "/surveys";

export const DIETARY_OPTIONS = "/dietary-options";
export const DIETARY_BOOKINGS = "/dietary-bookings";
export const DIETARY_TOTALS = "/dietary-booking-totals";
export const MEAL_OPTIONS = "/meal-options";
export const MEAL_MENUS = "/meal-menus";
export const MENU_ITEM_CATEGORIES = "/menu-item-categories";
export const MENU_ITEMS = "/menu-items";
export const MENU_TEMPLATES = "/menu-templates";
export const MENU_STRUCTURES = "/menu-structures";
export const SEMESTER_MENUS = "/semester-menus";
export const UPCOMING_MEALS = "/upcoming-meals";
export const MEAL_BOOKINGS = "/meal-bookings";
export const MEAL_BOOKING_SETTINGS = "/meal-booking-settings";
export const MEAL_BOOKINGS_TOTALS = "/meal-booking-totals";
export const MEAL_PLANS = "/meal-plans";
export const MEAL_PLAN_INTEGRITY_ERRORS = "/meal-plan-integrity-errors";
export const NOTIFICATIONS = "/notifications";
export const FEEDBACK = "/feedback";
export const ORDERS = "/orders";
export const SYSTEM = "/system-settings";
export const BATCH_TRANSACTIONS = "/batch-transactions";
export const TIMES = "/meal-times";
export const RESIDENCES = "/residences";
export const HOLIDAYS = "/holidays";
export const TERM_HOLIDAYS = "/term-holidays";
export const BALANCE = "/account-balance-settings";
export const FEES = "/fees";
export const CREATE_MERCHANT = "/create_merchant";
export const CREATE_SCANNER = "/create_scanner";
export const CREATE_KITCHEN = "/create_kitchen";
